"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    externalFilename: zod_1.z.string().describe('External filename'),
    externalReceivableIdField: zod_1.z
        .string()
        .optional()
        .describe('Document field to be used for external receivable id, if not part of filename'),
    externalReceivableIdRegEx: zod_1.z
        .string()
        .describe('Regex to extract externalReceivableId from the rawFilename. Must have a single capture group.'),
    decodeBase64: zod_1.z
        .boolean()
        .describe('If specified, regex extracted externalReceivableId will be decoded using base64.'),
    encryptionConfig: finley_types_1.Util.EncryptionConfigSchema.optional().describe('Encryption config'),
    outputFileExtension: finley_types_1.Util.SupportedFileExtensionSchema.optional().describe('Explicit output file extension'),
});
exports.nodeType = 'file_rawReceivableDocumentation';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    externalFilename: true,
});
exports.artifactType = 'rawReceivableDocumentation';
//# sourceMappingURL=types.js.map